"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortVariantsBy = void 0;
/**
 *
 *
 * @export
 * @param {string} option
 * @param {*} optionValues
 * @returns
 */

function sortVariantsBy(option, optionValues) {
  return function (a, b) {
    var values = optionValues[option];
    var aSearchValue = a.selectedOptions[option];
    var bSearchValue = b.selectedOptions[option];
    var result = values.indexOf(aSearchValue) - values.indexOf(bSearchValue);
    return values ? result : 0;
  };
}

exports.sortVariantsBy = sortVariantsBy;